<template>
  <div class="container" :class="{ 'container-wider': isCartPage }" v-if="genericHtml" v-html="genericHtml"></div>
</template>

<script>
  export default {
    name: 'generic-custom-code',

    props: {
      genericScript: {
        type: String,
        default: null
      },
      genericHtml: {
        type: String,
        default: null
      }
    },

    computed: {
      isCartPage () {
        return this.$route.name === 'cart'
      }
    },

    metaInfo () {
      return {
        script: [
          {
            skip: !this.genericScript,
            type: 'text/javascript',
            innerHTML: this.genericScript,
            body: true
          }
        ]
      }
    }
  }
</script>
